import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "slash",
  "use": "slash-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"slash\">\n<path d=\"M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9\n\tC21,7,17,3,12,3z\" />\n<path d=\"M19.1,20.1c-0.3,0-0.5-0.1-0.7-0.3L4.2,5.6c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l14.1,14.1c0.4,0.4,0.4,1,0,1.4\n\tC19.6,20,19.3,20.1,19.1,20.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol